import * as React from 'react';
import { CreditCard } from '@atlassian/cssxp-types-billing';
import './credit-card-detail.scss';

interface CreditCardDetailProps {
  creditCard: CreditCard;
}

const CreditCardDetail = (props: CreditCardDetailProps) => {
  const { creditCard } = props;

  return (
    <>
      <div className={'payment-info'}>
        <div className={'payment-row'}>
          <span className={'payment-data'}>**** **** **** {creditCard.lastFour}</span>
        </div>
        <div className={'payment-row'}>
          <span className={'payment-data'}>{creditCard.cardHolderName}</span>
          <span className={'payment-data'}>{`${creditCard.expirationMonth}/${creditCard.expirationYear}`}</span>
        </div>
      </div>
    </>
  );
};

export default CreditCardDetail;
